import React from "react";
import { Table, TableCell, TableContainer } from "@mui/material";
import {
  colonCellStyle,
  labelCellStyle,
  StyledTableBody,
  TableBodyRow,
  valueCellStyle,
} from "../../styles/TableStyles";
import { INDIAN_RUPEE_SIGN } from "../../constant/constant";

const InvoiceDetailsTable = ({ invoice }) => {
  const invoiceDetails = [
    ["Invoice ID", invoice.id],
    [
      "Invoice Date",
      `${new Date(invoice.invoice_date).toLocaleDateString("en-GB")}`,
    ],
    ["Tenant Name", `${invoice.tenant_first_name} ${invoice.tenant_last_name}`],
    ["Tenant Contact", invoice.tenant_contact],
    ["Rent Amount", `${INDIAN_RUPEE_SIGN} ${invoice.rent_amount}`],
    [
      "Electricity Per Unit Charge",
      invoice.per_unit_charge != null ? `${INDIAN_RUPEE_SIGN} ${invoice.per_unit_charge}`: null,
    ],
    ["Consumed Electricity Unit", invoice.total_electricity_unit],
    [
      "Electricity Bill",
      invoice.electricity_amount != null ? `${INDIAN_RUPEE_SIGN} ${invoice.electricity_amount}`: null,
    ],
    ["Overdue Amount", `${INDIAN_RUPEE_SIGN} ${invoice.overdue_amount}`],
    ["Invoice Amount", `${INDIAN_RUPEE_SIGN} ${invoice.invoice_amount}`],
    ["Paid Amount", `${INDIAN_RUPEE_SIGN} ${invoice.paid_amount}`],
  ].filter(Boolean);

  return (
    <TableContainer>
      <Table size="small" aria-label="tenant details table">
        <StyledTableBody>
          {invoiceDetails.map(([label, value]) => (
            <TableBodyRow key={label}>
              <TableCell sx={labelCellStyle}>{label}</TableCell>
              <TableCell sx={colonCellStyle}>:</TableCell>
              <TableCell sx={valueCellStyle}>{value}</TableCell>
            </TableBodyRow>
          ))}
        </StyledTableBody>
      </Table>
    </TableContainer>
  );
};

export default InvoiceDetailsTable;
